export default __webpack_public_path__ + "29648b2cc0c5b468a64293790a8d6da5.jpg";